import React, { useEffect } from 'react';

function RedirectComponent() {
  useEffect(() => {
    // Set URL path for redirect (current 404 page).
    window.location.href = '/error-404';
  }, []);

  return null;
}

export default RedirectComponent;
